import React from 'react';
import styles from './Row.module.css';

const Row = ({ label, children, hint }) => (
  <div className={styles.row}>
    <div className={styles.label}>{label}</div>
    <div className={styles.control}>{children}</div>
    {hint && <div className={styles.hint}>{hint}</div>}
  </div>
);

export default Row;
